import { SpyneTrait } from "spyne";

export class CodeSampleTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codeSample$";

    super(context, traitPrefix);
  }

  static codeSample$HelloWorld() {
    return `
        const data = { animals: [
        { animal: "Blue Whale", img: "imgs/animals/whale.webp", 
          dimensions: { length: "98", weight: "440,000" } },
        { animal: "Elephant",   img: "imgs/animals/elephant.webp", 
          dimensions: { length: "24.6", weight: "14,000" } },
        { animal: "Giraffe",    img: "imgs/animals/giraffe.webp", 
          dimensions: { length: "18", weight: "2,645" } }
      ]};

 
    const template = \` {{#animals}}
                          <section style="margin:0 1rem 1rem 0; max-width: 125px;">
                             <img src="{{img}}" width="100" alt="" />
                             <p style="margin:.5rem 0 0 0;">The <b>{{animal}}</b> 
                              can reach heights of up to {{dimensions.length}} feet,
                              and can weigh as much as {{dimensions.weight}} pounds.</p>
                          </section>
                        {{/animals}}\`

 
    const props = {
      tagName: "article",
      style: "font-family:sans-serif; display:flex;",
      data, template
    }

 
    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);
    
    `;
  }

  static codeSample$InstallStarterApp() {
    return `
    git clone https://github.com/spynejs/new-app.git my-app-name
    `;
  }

  static codeSample$SpyneAppInit(){
    return `
   import { SpyneApp } from 'spyne';

   const spyneApp = new SpyneApp.init({ debug: true });
    `
  }



  static codeSample$ViewStreamHelloWorld(){
    return `
   import {ViewStream} from 'spyne';

   new ViewStream({data: "Hello World"})
   .appendToDom(document.body);    
           
    `;
  }

  static codeSample$ViewStreamExample(){
    return `
    
    class MainView extends ViewStream {
      constructor(props = {}) {
        
      // VIEW:          ADD CONTENT                        
      props.template = \u0060&lt;h2&gt;&lt;/h2&gt;
                       \u200B&lt;button&gt;Click Me&lt;/button&gt;\u0060                                
  
      // BEHAVIOR:      ADD CHANNELS
      props.channels = ["CHANNEL_UI"]
  
      // LOGIC:         ADD METHODS
      props.traits = [HelloWorldTrait]
      super(props);
   }

    // BEHAVIOR: CONNECT EVENTS TO METHODS  
    addActionListeners() {
      return [["CHANNEL_UI_CLICK_EVENT", "hw$greet"]]
    }
  
    // BEHAVIOR: SEND LOCAL EVENTS
    broadcastEvents() {
      return [["button", "click"]]
    }
  
    // RENDER HOOK
    onRendered() {
      this.hw$greet()
    }
  }
  
  new MainView().appendToDom(document.body)
    
    `




    return `
    import { ViewStream } from 'spyne';
    import { HelloWorldTrait } from './hello-world-trait.js';
    
    class MainView extends ViewStream {
      constructor(props = {}) {
    
        // VIEW:      ADD CONTENT
        props.template = \`<h2></h2>
          <button>Click Me</button>\`;
    
        // BEHAVIOR:  ADD CHANNELS
        props.channels = ['CHANNEL_UI'];
    
        // LOGIC:     ADD METHODS
        props.traits = [HelloWorldTrait];
        super(props);
      }
    
      // BEHAVIOR: SEND LOCAL EVENTS
      broadcastEvents() {
        return [['button', 'click']];
      }
    
      // BEHAVIOR: CONNECT EVENTS TO METHODS
      addActionListeners() {
        return [['CHANNEL_UI_CLICK_EVENT', 'hw$greet']];
      }
    
      // RENDER HOOK
      onRendered() {
        this.hw$greet();
      }
    }
            
`;
  }


  static codeSample$ChannelStateExample(){
      return `
      
      import { Channel } from 'spyne';

      // State lives here, not in Views:
      // Views render from it, send actions to it, and dispose freely.
      class ChannelSteps extends Channel {
        constructor(props = {}) {
      
          // REPLAY: late-rendering Views receive current state immediately
          props.replay = true;
          super('CHANNEL_STEPS', props);
        }
      
        // STATE: set when the channel registers
        onRegistered() {
          this.sendChannelPayload('CHANNEL_STEPS_UPDATE_EVENT', { step: 1 });
        }
      
        // IN: a View sends an action
        // OUT: the channel advances state and re-emits
        onViewStreamInfo(payload) {
          const step = payload.data.step + 1;
          this.sendChannelPayload('CHANNEL_STEPS_UPDATE_EVENT', { step });
        }
      }
            
`;
  }

  static codeSample$WindowChannelConfig(){

    return `
        SpyneApp.init({
          channels: {
            WINDOW: {
        
              // GLOBAL EVENTS the channel captures
              events: ['resize', 'blur', 'online', 'offline'],
        
              // MEDIA QUERIES: each change emits
              // CHANNEL_WINDOW_MEDIA_QUERY_EVENT with its mediaQueryName
              mediaQueries: {
                desktop: '(min-width: 1024px)',
                mobile: '(max-width: 1023px)'
              }
            }
          }
        });
  `

  }

  static codeSample$RouteChannelConfig(){
    return `
    SpyneApp.init({
      channels: {
        ROUTE: {
          routes: {
    
            // FIRST URL SEGMENT: pageId
            routePath: {
              routeName: 'pageId',
              home: ['', 'index.html'],
    
              // SECOND URL SEGMENT: cardId, nested under page-1
              'page-1': {
                routePath: {
                  routeName: 'cardId',
                  'card-1': 'card-1'
                }
              }
            }
          }
        }
      }
    }); 
    
    `
  }

  static codeSample$RouteChannelSync(){

    return `
    import { ViewStream } from 'spyne';
    import { RouteTrait } from './route-trait.js';
    
    class PageView extends ViewStream {
      constructor(props = {}) {
        props.traits = [RouteTrait];
        props.channels = ['CHANNEL_ROUTE'];
        super(props);
      }
    
      // Every route action reaches one method,
      // which reads pageId / cardId from the payload's routeData
      addActionListeners() {
        return [['CHANNEL_ROUTE_.*_EVENT', 'route$onEvent']];
      }
    }
    
`;

  }

  static codeSample$RegisterPlugin(){

    return `
    import { SpyneApp } from 'spyne';
    import { MyPlugin } from './my-plugin.js';
    
    SpyneApp.init(config);
    
    // Same idiom as channels: an initialized instance, registered at init
    SpyneApp.registerPlugin(new MyPlugin());
    `;


  }


  static codeSample$SpyneAppInitClaude(){
    const template = "&lt;h2&gt;Hello SpyneJS&lt;/h2&gt;";

    return `
    
   import { SpyneApp, ViewStream } from 'spyne';
    
   SpyneApp.init({ debug: true });
   
   const appView = new ViewStream({
     data: "<h3>Hello SpyneJS</h3>"
   })
   
   appView().appendToDom(document.body);
 
   // outputs &lt;div&gt;&lt;h3&gt;Hello SpyneJS&lt;/h3&gt&lt;/div&gt;
   
`

  }


  static codeSample$ViewStreamHelloWorldParagraph(){
    return `
   import {ViewStream} from 'spyne';

   new ViewStream({
    data: "Hello World"
   })
   .appendToDom(document.body);

    `;
  }

  static codeSample$SpyneAppRegister(){
    return `
    // Register the custom channel with the Spyne app
    spyneApp.registerChannel(new MyChannel());

    // Register the console plugin, passing in any options (e.g., minimize: true)
    spyneApp.registerPlugin(
      new SpynePluginConsole({ minimize: true })
    );

    `
  }

  static codeSample$SpyneAppRegisterChannels(){
    return `
    
    // Register the custom channel with the Spyne app
    spyneApp.registerChannel(new MyChannel());

    // Register the console plugin, passing in any options (e.g., minimize: true)
    spyneApp.registerPlugin(
      new SpynePluginConsole({ minimize: true })
    );

    `
  }

  static codeSample$AppViewRoot() {
    return `

    import { AppView } from './app/app-view.js';

    new AppView().prependToDom(document.body);

    `;
  }

  static codeSample$IndexJsCanonical() {
    return `


      import 'main.scss';
      import { SpyneApp } from 'spyne';
      import { AppModelChannel } from 'channels/app-model-channel.js';
      import { AppView } from 'components/app-view.js';

      const config = {"debug": true,
                      "channels": {
                        "ROUTE": {
                          "routes": {
                            "routePath": {
                              "routeName": "pageId",
                              "home": ["", "index.html"]
                            }
                          }
                        },
                        "WINDOW": {
                          "events": ["click"],
                          "listenForResize": true
                        }
                      }
                    }

      SpyneApp.init(config);

      SpyneApp.registerChannel(new AppModelChannel());

      new AppView().prependToDom(document.body);


    `;
  }

  static codeSample$DevToolsImport() {
    return `

      import './scss/app.scss';
      import { SpyneApp } from 'spyne';
      import { AppView } from './app/app-view.js';

      SpyneApp.init({ debug: true });

      if (process.env.NODE_ENV === 'development') {
        import('./dev-tools.js').then(({ devToolsReady }) => {
          devToolsReady.then(() => {
            new AppView().prependToDom(document.querySelector('body'));
          });
        });
      } else {
        new AppView().prependToDom(document.querySelector('body'));
      }
    `;
  }


  static codeSample$SpyneAppRegistering(){
    return `
    // Import the main Spyne application class from the 'spyne' library
    import { SpyneApp } from 'spyne';

    // Import your custom channel from the local 'channels' directory
    import { MyChannel } from 'channels/my-custom-channel.js';

    // Import the console plugin from 'spyne-plugin-console'
    import { SpynePluginConsole } from 'spyne-plugin-console';

    // Create a new instance of the Spyne app (or assume it's already globally available)
    // const spyneApp = new SpyneApp(); // Uncomment if you need to instantiate.

    // Initialize the Spyne app with debugging enabled
    spyneApp.init({ debug: true });

    // Register the custom channel with the Spyne app
    spyneApp.registerChannel(new MyChannel());

    // Register the console plugin, passing in any options (e.g., minimize: true)
    spyneApp.registerPlugin(
      new SpynePluginConsole({ minimize: true })
    );

    `
  }

  static codeSample$NavLinkExample(){
    return `
     &lt;a data-channel="ROUTE" data-page-id="home" href="" alt=""&gt;home&lt;/a&gt;
    `
  }

  static codeSample$ModalConfigExample(){
    return `
   {
    "channels": {
      "ROUTE": {
        \u200A"routes"\u200D: {
          "routePath": {
            "routeName": "pageId",
            "home": ["", "index.html"],
            "page-1": {
              "routePath": {
                "routeName": "cardId",
                "card-1": "card-1"
              }
            }
          }
        }
      }
    }
  }
    `
  }

  static codeSample$ModalSecurityConfigExample(){
    return `
   {
    "debug": true,
    "strict": true,
    "mode": "app",
    "disableSanitize": false,
    "iframes": {
      "allow": true,
      "allowedOrigins": ["https://www.youtube.com"],
      "sandbox": "allow-scripts allow-same-origin allow-popups"
    },
    "anchors": {
      "allowTarget": true,
      "addNoopener": true,
      "allowedDomains": ["https://github.com"]
    },
    "customElements": ["my-widget"]
  }
    `
  }

  static codeSample$ModalRoutePathExample(){
    return `
  { routeName: "pageId"
    "page-1": ["page-one", "page-1"]
  }

`
  }
  static codeSample$ModalRoutePathStructure(){
    return `
  { routeName: "key"
    "routeProperty": "valueForURLSegment"
  }
    `
  }

  static codeSample$ModalRoutePathResultingURLs(){
    return `
    Slash notation: /page-one
    Query notation: ?pageId=page-one
    Hash notation:  /#page-one
    `
  }
  static codeSample$ModalRoutePathEmittedData(){
    return `
    {
      "pageId": "page-1"
    }

    `
  }

  static codeSample$ModalRoutePathLinkExample(){
    return `
   &lt;a data-channel="ROUTE" data-page-id="page-1"&gt;Page One&lt;/a&gt;
    `
  }

  static codeSample$RouteLinkExample(){
    return `
    &lt;a data-channel="ROUTE" data-page-id="my-page" data-end-route="true"
      href="/my-page" alt="my-link"&gt;My Page&lt;/a&gt;
    `
  }
  static codeSample$RouteLinkExampleOld(){
    return `
     &lt;a data-channel="ROUTE" data-page-id="my-page" data-card-id="my-card" href="/my-page/my-card"&gt;my-card link&lt;/a&gt;
    `
  }
  static codeSample$RouteLinkURLs(){
    return `
    // Slash style
    /my-page/my-card

    // Query Parameter style
    ?pageId=my-page&cardId=my-card

    // Hash Fragment style
    /#my-page/my-card
    `
  }

  static codeSample$RoutePayload(){
    return `
     {
      "action": "CHANNEL_ROUTE_CHANGE_EVENT",
      "payload": {
        "isDeepLink": false,
        "routeCount": 1,
        "routeData": {
          "pageId": "my-page",
          "cardId": "my-card",
          "channel": "ROUTE",
          "eventPreventDefault": "true"
        },
        "routeValue": "my-page/my-card"
      }
    }
    `

  }

  static codeSample$ActionLabelNaming(){
    return `
     CHANNEL_NAME_[THE-EVENT]_EVENT
    `
  }

  static codeSample$ClickActionLabel(){
    return `
  CHANNEL_NAME_CLICK_EVENT
    `
  }
  static codeSample$AppendToDom() {
    return `

    new ViewStream({}).prependToDom(document.body);
    new ViewStream({}).appendToDom(document.body);


    const myCustomViewStream =  new MyCustomViewStream();
    myCustomViewStream.prependToDom(document.body);
    myCustomViewStream.appendToDom(document.body);


    `;
  }

  static codeSample$ActionListeners() {
    return `

    addActionListeners() {
      return [
        ['CHANNEL_UI_CLICK_EVENT',    'onClickEvent'],
        ['CHANNEL_CUSTOM_MAIN_EVENT', 'onChannelCustomEvent']
      ];
    }

    `;
  }

  static codeSample$SpyneCliCreate() {
    return `
    npx spyne-cli create-app my-app
    `;
  }

  static codeSample$SpyneCliClasses() {
    return `
    npx spyne-cli

    Select file type
    ❯ ViewStream
      Channel
      SpyneTrait

      `;
  }

  static codeSample$BroadcastEvents() {
    return `

     broadcastEvents() {
        return [
            ['button', 'click'],
            ['input',  'keypress']
        ];
    }

    `;
  }

  static codeSample$PayloadFilters() {
    return `

    const payloadFilter = new ChannelPayloadFilter({
       action: (val) => val!=="CHANNEL_ROUTE_CONFIG_UPDATED_EVENT",
       payload: pathEq(['routeData', 'eventType'], 'menuDrawer')
    })

    `;
  }

  static codeSample$InitSpyne() {
    return `
    import {SpyneApp} from 'spyne';

      SpyneApp.init({
        debug:true
      });

        `;
  }

  static codeSample$Traits() {
    return `
     // STEP ONE: Import Trait classes
     import {MyFirstTrait} from 'traits/my-first-trait-traits';
     import {MySecondTrait} from 'traits/my-first-trait-traits';

     export class MyView extends ViewStream {
         constructor(props={}) {

     // STEP TWO: Add imported Traits to props
             props.traits = [MyFirstTrait, MySecondTrait];
             super(props);
        }

        onRendered(){

     // STEP THREE: All trait methods can now
     //             be used as native methods
            this.firstTrait$CustomMethod();
            this.secondTrait$CustomMethod();
        }

     }

`;
  }

  static codeSample$BroadcastEventsValues() {
    return `
  abort                    gestureend                  reset
  activate                 gesturestart                resize
  addtrack                 gotpointercapture           resourcetimingbufferfull
  afterprint               hashchange                  result
  afterscriptexecute       icecandidate                resume
  animationcancel          icecandidateerror           scroll
  animationend             iceconnectionstatechange    search
  animationiteration       icegatheringstatechange     seeked
  animationstart           input                       seeking
  appinstalled             inputsourceschange          select
  audioend                 install                     selectedcandidatepairchange
  audiostart               invalid                     selectend
  auxclick                 keydown                     selectionchange
  beforeinput              keyup                       selectstart
  beforeprint              languagechange              shippingaddresschange
  beforeunload             leavepictureinpicture       shippingoptionchange
  beginevent               load                        signalingstatechange
  blocked                  loadeddata                  slotchange
  blur                     loadedmetadata              soundend
  boundary                 loadend                     soundstart
  bufferedamountlow        loadstart                   speechend
  cancel                   lostpointercapture          speechstart
  canplay                  mark                        squeeze
  canplaythrough           merchantvalidation          squeezeend
  change                   message                     squeezestart
  click                    messageerror                stalled
  close                    mousedown                   start
  closing                  mouseenter                  statechange
  complete                 mouseleave                  storage
  compositionend           mousemove                   submit
  compositionstart         mouseout                    success
  compositionupdate        mouseover                   suspend
  connect                  mouseup                     timeout
  connectionstatechange    mute                        timeupdate
  contentdelete            negotiationneeded           toggle
  contextmenu              nomatch                     tonechange
  copy                     notificationclick           touchcancel
  cuechange                offline                     touchend
  cut                      online                      touchmove
  datachannel              open                        touchstart
  dblclick                 orientationchange           track
  devicechange             pagehide                    transitioncancel
  devicemotion             pageshow                    transitionend
  deviceorientation        paste                       transitionrun
  domcontentloaded         pause                       transitionstart
  drag                     payerdetailchange           unhandledrejection
  dragend                  paymentmethodchange         unload
  dragenter                play                        unmute
  dragleave                playing                     upgradeneeded
  dragover                 pointercancel               versionchange
  dragstart                pointerdown                 visibilitychange
  drop                     pointerenter                voiceschanged
  durationchange           pointerleave                volumechange
  emptied                  pointerlockchange           vrdisplayactivate
  end                      pointerlockerror            vrdisplayblur
  endevent                 pointermove                 vrdisplayconnect
  ended                    pointerout                  vrdisplaydeactivate
  enterpictureinpicture    pointerover                 vrdisplaydisconnect
  error                    pointerup                   vrdisplayfocus
  focus                    popstate                    vrdisplaypointerrestricted
  focusin                  progress                    vrdisplaypointerunrestricted
  focusout                 push                        vrdisplaypresentchange
  formdata                 pushsubscriptionchange      waiting
  fullscreenchange         ratechange                  webglcontextcreationerror
  fullscreenerror          readystatechange            webglcontextlost
  gamepadconnected         rejectionhandled            webglcontextrestored
  gamepaddisconnected      removetrack                 webkitmouseforcechanged
  gatheringstatechange     removestream                webkitmouseforcedown




    `;
  }

  static codeSample$ViewStreamAttributes() {
    return `
  // Global Attributes
  'accesskey', 'class', 'contenteditable', 'dir', 'draggable', 'hidden',
  'id', 'lang', 'spellcheck', 'style', 'tabindex', 'title', 'translate',

  // Specific Attributes for input
  'accept', 'autocomplete', 'autofocus', 'checked', 'dirname', 'disabled',
  'form', 'formaction', 'formenctype', 'formmethod', 'formnovalidate',
  'formtarget', 'list', 'max', 'maxlength', 'min', 'minlength',
  'multiple', 'name', 'pattern', 'placeholder', 'readonly', 'required',
  'size', 'step',  'value',

  // Specific Attributes for img
  'alt', 'srcset', 'sizes', 'usemap', 'ismap',

  // Specific Attributes for a and link
  'href', 'target', 'download', 'ping', 'rel', 'hreflang', 'as', 'media',

  // Specific Attributes for form
  'accept-charset', 'action', 'enctype', 'novalidate',

  // Specific Attributes for meta
  'content', 'charset', 'http-equiv',

  // Specific Attributes for script
  'async', 'defer',  'integrity', 'nomodule', 'nonce', 'referrerpolicy',

  // Accessiblity Attributes
  'aria-autocomplete', 'aria-checked', 'aria-disabled', 'aria-expanded',
  'aria-haspopup', 'aria-hidden', 'aria-invalid', 'aria-label',
  'aria-level', 'aria-multiline', 'aria-multiselectable',
  'aria-orientation', 'aria-pressed', 'aria-readonly', 'aria-required',
  'aria-selected', 'aria-sort', 'aria-valuemax', 'aria-valuemin',
  'aria-valuenow', 'aria-valuetext', 'aria-atomic', 'aria-busy',
  'aria-live', 'aria-relevant', 'aria-dropeffect', 'aria-grabbed',
  'aria-activedescendant', 'aria-controls', 'aria-describedby',
  'aria-flowto', 'aria-labelledby', 'aria-owns', 'aria-posinset',
  'aria-setsize',

  // Other Element-specific Attributes
  'autocapitalize', 'autoplay', 'buffered', 'challenge', 'cite', 'code',
  'codebase', 'color', 'cols', 'colspan', 'contextmenu', 'controls',
  'coords', 'crossorigin', 'csp', 'dataset', 'datetime', 'decoding',
  'default', 'for', 'headers', 'high', 'icon', 'importance', 'itemprop',
  'keytype', 'kind', 'label', 'language', 'lazyload', 'loop', 'low',
  'manifest',  'method', 'muted', 'open', 'optimum', 'poster', 'preload',
  'radiogroup', 'reversed', 'role', 'rows', 'rowspan', 'sandbox', 'scope',
  'scoped', 'selected', 'shape', 'slot', 'span', 'srcdoc', 'src', 'type',
  'srclang', 'start', 'summary', 'wrap', 'width', 'height'
    `;
  }
}
